<app-navbar *ngIf="insideFocus"></app-navbar>
<app-call-slideup-popover [hidden]="!insideFocus" [allPermission]="allPermission"></app-call-slideup-popover>
<!-- overlay confined to the content area below the header, instead of *ngIf-removing the outlet, so route content isn't destroyed/recreated on every navigation and the header is never covered/dimmed -->
<div class="route-outlet-container">
    <span *ngIf="isLoading && insideFocus" class="route-loading-overlay">
        <img src="../assets/loader/Loader2.gif" alt="" width="76px" height="76px">
    </span>
    <router-outlet></router-outlet>
</div>